<template>
  <div class="withdrawdetail">
    <div class="date_box">
      <p>提现时间：{{ withdrawDetailInfo.withdrawDate }}</p>
      <p class="money">
        <span class="money_icon">￥</span>
        <span class="red">{{ withdrawDetailInfo.actualAmount }}</span>
        <img src="../../../assets/image/nsale/help.png" alt @click="goPage" />
      </p>
    </div>
    <!-- 银行卡明细 -->
    <div class="card_box">
      <h3 class="title">
        <span class="title_text">银行卡明细</span>
        <div class="img_box" @click="cardListShow = !cardListShow">
          <img src="../../../assets/image/nsale/arrow2.png" alt />
        </div>
      </h3>
      <div v-if="cardListShow">
        <ul v-for="(item, index) in withdrawDetailInfo.childWL" :key="index">
          <li>银行卡：{{ item.bankCard || "-" }}</li>
          <li>
            提现金额：{{ item.actualAmount ? `${item.actualAmount}元` : "-" }}
          </li>
          <li class="last_child">支付日期：{{ item.payDate || "-" }}</li>
        </ul>
      </div>
    </div>
    <!-- 保单明细 -->
    <div class="policy_box">
      <h3 class="title">
        <span class="title_text">保单明细</span>
        <div class="img_box" @click="policyListShow = !policyListShow">
          <img src="../../../assets/image/nsale/arrow2.png" alt />
        </div>
      </h3>
      <div
        class="content"
        v-if="policyListShow && withdrawPolicyRecordList.length > 0"
      >
        <ul v-for="(item, index) in withdrawPolicyRecordList" :key="index">
          <li class="flex policy_name">
            <span>{{ item.product }}</span>
            <span class="integral_num">{{ item.integral }}</span>
          </li>
          <li class="flex">
            <span>投保人：{{ item.accName }}</span>
            <span>{{
              item.cooperationMode == "1" ? "积分金额" : "宣传奖励"
            }}</span>
          </li>
          <li>投保日期：{{ item.effectiveDate }}</li>
          <li class="last_child">
            <span>保单号：{{ item.policyNo }}</span>
            <span>出单用户:{{ item.agentName }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/utils/api";
export default {
  data() {
    return {
      date: "2021/12/12",
      cardListShow: true,
      policyListShow: true,
      withdrawDetailInfo: {}, //提现信息
      withdrawPolicyRecordList: [], //保单列表
    };
  },
  created() {
    this.getCashOutDetail();
  },
  computed: {},
  methods: {
    // 页面跳转
    goPage() {
      this.$store.commit("setWithdrawDetailInfo", this.withdrawDetailInfo);
      this.$router.push({
        path: "/bs/withdrawalamount",
      });
    },
    getCashOutDetail() {
      //获取转账详情
      let data = {
        name: this.$route.query.name,
        userId: this.$route.query.userId,
      };
      api.cashOutDetail(data).then((res) => {
        if (res.data.content) {
          this.withdrawDetailInfo = res.data.content.withdrawRecordMain;
          // 如果没有银行卡明细，并且提现金额为负数
          if (
            !(
              this.withdrawDetailInfo.childWL &&
              this.withdrawDetailInfo.childWL.length > 0
            ) &&
            this.withdrawDetailInfo.actualAmount < 0
          ) {
            // 设置固定银行卡明细
            this.withdrawDetailInfo.childWL = [
              {
                bankCard: "负数积分返还",
                actualAmount: this.withdrawDetailInfo.actualAmount,
                payDate: this.withdrawDetailInfo.withdrawDate,
              },
            ];
          }
          this.withdrawPolicyRecordList =
            res.data.content.withdrawPolicyRecordList;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.withdrawdetail {
  font-size: 12px;
  text-align: left;
  font-family: PingFangSC-Regular, PingFang SC;
  background: #fff;
  min-width: 100vw;
  min-height: 100vh;
  padding: 15px 20px;
  box-sizing: border-box;

  .date_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 55px;
    background: #f9f9f9;
    border-radius: 10px;
    padding: 0 15px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;

    p {
      height: 55px;
      line-height: 55px;

      .money_icon {
        font-size: 9px;
        font-family: HelveticaNeue-Bold, HelveticaNeue;
        font-weight: bold;
        color: #ff7c6d;
        line-height: 11px;
      }

      .red {
        font-size: 16px;
        font-family: HelveticaNeue-Bold, HelveticaNeue;
        font-weight: bold;
        color: #ff7c6d;
        line-height: 11px;
      }

      img {
        width: 14px;
        margin-left: 7px;
        position: relative;
        top: 2px;
        vertical-align: center;
      }
    }
  }

  .title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #666666;
    line-height: 20px;

    .img_box {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
    }

    img {
      width: 8.5px;
      height: 9.5px;
    }
  }

  .card_box {
    padding: 15px 21px;
    background: #f9f9f9;
    border-radius: 10px;
  }

  .card_box .title {
    margin-bottom: 7px;
  }

  .policy_box .content {
    padding: 15px 21px;
    background: #f9f9f9;
    border-radius: 10px;
  }

  .policy_box .title {
    margin-bottom: 9px;
  }

  .policy_box .title .title_text {
    margin-left: 15px;
  }

  .policy_box .title img {
    margin-right: 15px;
  }

  .card_box,
  .policy_box {
    width: 100%;
    margin-top: 15px;

    ul {
      margin-bottom: 20px;
      border-bottom: 1px solid #ececec;

      li {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #666666;
        line-height: 16.5px;
        margin-bottom: 4px;
      }

      li.flex {
        display: flex;
        justify-content: space-between;
      }

      li.last_child {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0;
        padding-bottom: 21.5px;
      }

      .policy_name {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        padding-bottom: 7px;
        .integral_num {
          font-size: 16px;
          font-family: HelveticaNeue-Bold, HelveticaNeue;
          font-weight: bold;
          color: #ff7c6d;
        }
      }
    }

    ul:last-child {
      margin-bottom: 0;
      border-bottom: none;

      li.last_child {
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
}
</style>
